import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import Flex from '~/components/Flex';

// import './BiaIcon.css'

export type BiaIconProps = FontAwesomeIconProps & {
  onClick?: () => void;
};

const BiaIcon: React.FC<BiaIconProps> = ({
  icon,
  className = '',
  onClick,
  style = {},
  rotate = 0,
  ...props
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Don't render FontAwesome on server to avoid hydration mismatch
  if (!isMounted) {
    return <div className={`${className} ${onClick && 'cursor-pointer'}`} style={style} />;
  }

  return (
    <Flex justify='center' className={`${className} ${onClick && 'cursor-pointer'}`}>
      <FontAwesomeIcon
        style={style}
        icon={icon as IconProp}
        onClick={onClick ? e => {
          e.stopPropagation();
          onClick();
        } : undefined}
        size={props.size}
        rotation={[90, 180, 270].includes(Number(rotate)) ? (Number(rotate) as 90 | 180 | 270) : undefined}
        {...props}
      />
    </Flex>
  );
};


export default BiaIcon;
